<template>
  <div class="bg-[#1E1E1ED9] sticky flex flex-col items-center justify-between w-full top-0 z-50 backdrop-blur-sm">
    <div class="relative py-[24px] w-full px-[48px] xl:px-0 md:py-[27px] lg:max-w-[1280px] lg:px-[102px]">
      <header class="flex items-center justify-between px-0 w-full top-0 z-40 md:relative xl:max-w-[1280px]">
        <a href="/" title="Vip Financeira" rel="follow" class="w-[40px] md:w-[auto]">
          <img width="88" src="/img/logos/vip.svg" alt="Vip Financeira" />
        </a>
        <ul class="hidden xl:flex items-center gap-[20px]">
          <li v-for="(menu, index) in menus" :key="index">
            <Link :link="menu.link" :label="menu.label" :type="menu.type" class="hover:text-selective-yellow"
              :class="menu.active ? 'text-selective-yellow' : 'text-white'" />
          </li>
          <li>
            <LinkButton customClass="!py-[10px] !px-[25px] !w-auto !text-[16px]" :url="whatsappUrl" />
          </li>
        </ul>

        <button class="grid xl:hidden" @click="toggle">
          <img width="18" src="/img/icons/sandwitch-menu.svg" alt="Vip Financeira" class="w-[18px] lg:w-[35px]" />
        </button>
      </header>
      <ul id="mobile-menu"
        class="absolute top-100 left-0 flex xl:hidden flex-col gap-8 transition-all ease-linear bg-[--black] rounded-b-lg px-8"
        :class="!isMenuOpen && '-translate-x-full'">
        <li v-for="(menu, index) in menus" :key="index">
          <Link :link="menu.link" :label="menu.label" :type="menu.type"
            class="hover:text-selective-yellow flex leading-2 font-semibold text-base h-12 items-center justify-center"
            :class="menu.active ? 'text-selective-yellow' : 'text-white'" />
        </li>
        <li>
          <LinkButton customClass="!py-[10px] !px-[25px] !w-auto !text-[16px]" :url="whatsappUrl" />
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import Link from "./Link.vue"
import LinkButton from "./LinkButton.vue"
import { useWhatsappUrl } from "@/composables/useWhatsappUrl"

export default {
  name: "THeader",
  components: {
    Link,
    LinkButton,
  },
  setup() {
    const { whatsappUrl } = useWhatsappUrl('Olá, gostaria de simular minha antecipação do FGTS.')
    return { whatsappUrl }
  },
  data() {
    return {
      isMenuOpen: false,
      menus: [
        {
          label: "Home",
          link: "home",
          active: true,
          type: "anchor",
        },
        {
          label: "Vantagens",
          link: "vantagens",
          active: false,
          type: "anchor",
        },
        {
          label: "Sobre nós",
          link: "sobre",
          active: false,
          type: "anchor",
        },
        {
          label: "Como obter",
          link: "como-obter",
          active: false,
          type: "anchor",
        },
        {
          label: "Depoimentos",
          link: "depoimentos",
          active: false,
          type: "anchor",
        },
        {
          label: "FAQ",
          link: "faq",
          active: false,
          type: "anchor",
        },
        {
          label: "Blog",
          link: "https://blog.vipfinanceira.com.br/",
          active: false,
          type: "external",
        },
      ],
    }
  },
  methods: {
    toggle() {
      this.isMenuOpen = !this.isMenuOpen
    },
  },
}
</script>
